import styles from './index.module.sass';
import useStore from './store';
import SVG from 'react-inlinesvg';

const getBoardDialogData = (action, callback) => {
  if (action === null) return null;

  switch (action.type) {
    case 'action_dialog':
      return {
        image: action.actionDialog.image,
        title: action.actionDialog.title,
        content: action.actionDialog.message,
        buttons: [
          { theme: 'positive', content: action.actionDialog.positiveButton },
        ],
        action: () => {
          if (getBoardDialogData(action?.actionDialog.action)) {
            callback({
              type: 'hint_board',
              ...getBoardDialogData(action.actionDialog.action, callback),
            });
          } else {
            callback(null);
          }
        },
      };
    case 'alert_dialog':
      return {
        image: action.alertDialog.image,
        title: action.alertDialog.title,
        content: action.alertDialog.message,
        buttons: [
          { theme: 'positive', content: action.alertDialog.positiveButton },
          { theme: 'cancel', content: action.alertDialog.negativeButton },
        ],
        action: () => {
          if (getBoardDialogData(action.alertDialog.action)) {
            callback({
              type: 'hint_board',
              ...getBoardDialogData(action.alertDialog.action, callback),
            });
          } else {
            callback(null);
          }
        },
      };
    case 'message_box':
      return {
        title: action.messageBox.title,
        content: action.messageBox.message,
        buttons: [
          { theme: 'positive', content: action.messageBox.positiveButton },
        ],
        image: action.messageBox.image,
      };
    default:
      return null;
  }
};

const Hint = () => {
  const store = useStore();

  if (!store.hintBoard) return <></>;

  const clickableType = [
    'action_dialog',
    'alert_dialog',
    'message_box',
    'open_link',
  ];

  const Icon = () => {
    return clickableType.indexOf(store.hintBoard.action.type) !== -1 ? (
      <SVG src="/assets/chevron-right.svg" width={16} height={16} />
    ) : (
      ''
    );
  };

  const onClick = () => {
    const { action } = store.hintBoard;

    switch (action.type) {
      case 'action_dialog':
      case 'alert_dialog':
      case 'message_box':
        store.setBarcodePaymentDialog({
          type: 'hint_board',
          ...getBoardDialogData(action, store.setBarcodePaymentDialog),
        });
        break;
      case 'open_link':
        window.location.href = action.openLink.uri;
        break;
      default:
        return '';
    }
  };

  return (
    <div className={styles.hint} onClick={onClick}>
      {store.hintBoard.title}
      <Icon />
    </div>
  );
};

export default Hint;
